import "./App.css";
import { register } from "swiper/element/bundle";
import "./Style/scss/_index.scss";
import AppRoutes from "./AppRoutes/AppRoutes";
import DocumentLoader from "./components/Modals/DocumentLoader";

function App() {
  register();
  return (
    <div>
      <AppRoutes />
      <DocumentLoader />
    </div>
  );
}

export default App;
